/* ============================================
   NOTHING. — Global JS
   assets/nothing-global.js
   ============================================ */

(function () {
  'use strict';

  // --- Custom Cursor ---
  var cursor = document.getElementById('nothing-cursor');
  if (cursor) {
    document.addEventListener('mousemove', function (e) {
      cursor.style.transform = 'translate3d(' + e.clientX + 'px, ' + e.clientY + 'px, 0)';
    });
  }

  // --- Scroll-based nav ---
  var nav = document.getElementById('nothing-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 50) {
        nav.classList.add('nothing-nav--scrolled');
      } else {
        nav.classList.remove('nothing-nav--scrolled');
      }
    }, { passive: true });
  }
})();
